import * as ng from 'angular';
import 'angular';
import './content_partial.html';
import './title_bar.html';
import {RootScope} from "../types/angular-types";

interface IScope extends RootScope {
    layout: {
        partialContent: string;
        partialTitleBar: string;
        view: string;
        hasRightSidebar: boolean;
        showRightSidebar: boolean;
        showUploadPane: boolean;
        httpStatus: number
    };
}

angular.module('GorillaBoy.Dboard')
.controller('dboardController', [
    '$scope',
    '$log',
    'View',
    function dboardController($scope : IScope, $log: ng.ILogService, View: string) {
        $log.info("dboardController init");
        // SECTION: Layout code
        $scope.layout = {
            partialContent: './dboard/content_partial.html',
            partialTitleBar: './dboard/title_bar.html',
            view: View,
            hasRightSidebar: false,
            showRightSidebar: false,
            showUploadPane: false,
            httpStatus: null
        };
    }
]);
